import jQuery from 'jquery'

jQuery(document).ready(function ($) {
  const $eventSchedule = $('.dhsv_vc_sprintrace_event_schedule')

  if ($eventSchedule.length === 0) {
    return
  }

  $eventSchedule.each(function () {
    const $container = $(this)
    const $dayLinks = $container.find(
      '.dhsv_vc_sprintrace_event_schedule__day-link'
    )
    const $days = $container.find('.dhsv_vc_sprintrace_event_schedule__day')
    const $sidebar = $container.find(
      '.dhsv_vc_sprintrace_event_schedule__sidebar'
    )

    // Function to check if mobile
    function isMobile() {
      return $(window).width() < 992 // md breakpoint
    }

    // Function to ensure days maintain their order on mobile
    function updateDayOrder() {
      if (isMobile()) {
        $days.each(function () {
          const $day = $(this)
          const dayIndex = parseInt($day.data('day-index'), 10)
          $day.css('order', dayIndex)
        })
      } else {
        // Remove order property on desktop
        $days.css('order', '')
      }
    }

    // Function to update sidebar visibility based on active day
    function updateSidebarVisibility(activeDayIndex) {
      $dayLinks.each(function () {
        const $link = $(this)
        const linkDayIndex = parseInt($link.data('day-index'), 10)

        if (linkDayIndex === activeDayIndex) {
          $link.addClass('dhsv_vc_sprintrace_event_schedule__day-link--hidden')
        } else {
          $link.removeClass(
            'dhsv_vc_sprintrace_event_schedule__day-link--hidden'
          )
        }
      })
      updateSidebarVisibilityState()
    }

    // Function to check if all day links are hidden and hide/show sidebar accordingly
    function updateSidebarVisibilityState() {
      const allLinksHidden =
        $dayLinks.length > 0 &&
        $dayLinks.filter(
          ':not(.dhsv_vc_sprintrace_event_schedule__day-link--hidden)'
        ).length === 0

      if (allLinksHidden) {
        $sidebar.addClass('dhsv_vc_sprintrace_event_schedule__sidebar--hidden')
      } else {
        $sidebar.removeClass(
          'dhsv_vc_sprintrace_event_schedule__sidebar--hidden'
        )
      }
    }

    // Initialize: set day order and hide the first day (index 0) since it's active by default
    updateDayOrder()
    updateSidebarVisibility(0)
    updateSidebarVisibilityState()

    // Update day order on window resize
    $(window).on('resize', function () {
      updateDayOrder()
    })

    // Accordion: toggle time-slot expandable content
    $container
      .find('.dhsv_vc_sprintrace_event_schedule__toggle')
      .on('click', function () {
        const $btn = $(this)
        const $slot = $btn.closest(
          '.dhsv_vc_sprintrace_event_schedule__time-slot'
        )
        const $content = $slot.find(
          '.dhsv_vc_sprintrace_event_schedule__time-slot-content'
        )
        $slot.toggleClass(
          'dhsv_vc_sprintrace_event_schedule__time-slot--collapsed'
        )
        const isExpanded = !$slot.hasClass(
          'dhsv_vc_sprintrace_event_schedule__time-slot--collapsed'
        )
        $content.attr('hidden', !isExpanded)
        $btn.attr('aria-expanded', isExpanded)
      })

    // Handle day link clicks
    $dayLinks.on('click', function () {
      const $clickedLink = $(this)
      const dayIndex = parseInt($clickedLink.data('day-index'), 10)
      const $clickedDay = $days.filter(`[data-day-index="${dayIndex}"]`)

      if (isMobile()) {
        // Mobile: toggle the clicked timetable
        $clickedDay.toggleClass(
          'dhsv_vc_sprintrace_event_schedule__day--active'
        )

        // Update sidebar visibility based on toggle state
        const isActive = $clickedDay.hasClass(
          'dhsv_vc_sprintrace_event_schedule__day--active'
        )
        if (isActive) {
          $clickedLink.addClass(
            'dhsv_vc_sprintrace_event_schedule__day-link--hidden'
          )
        } else {
          $clickedLink.removeClass(
            'dhsv_vc_sprintrace_event_schedule__day-link--hidden'
          )
        }
        updateSidebarVisibilityState()
      } else {
        // Desktop: replace active timetable (original behavior)
        // Remove active class from all days
        $days.removeClass('dhsv_vc_sprintrace_event_schedule__day--active')

        // Add active class to corresponding day
        $clickedDay.addClass('dhsv_vc_sprintrace_event_schedule__day--active')

        // Update sidebar visibility: hide clicked day, show all others
        updateSidebarVisibility(dayIndex)
      }
    })
  })
})
